module.exports = __webpack_public_path__ + "static/marching-duodrone-mtg_clb-95f06a19bf96415311151c0841df9847.webp";